import { DASHBOARD_DESCRIPTION_MAX_LENGTH } from '@modules/dashboard/constants';
import { Stack, TextField, Typography } from '@mui/material';

interface DashboardDescriptionInputProps {
  description: string;
  onDescriptionChange: (description: string) => void;
}

export const DashboardDescriptionInput = ({
  description,
  onDescriptionChange,
}: DashboardDescriptionInputProps) => {
  const isCharacterLimitExceeded =
    description.length > DASHBOARD_DESCRIPTION_MAX_LENGTH;

  return (
    <Stack alignItems="flex-end" spacing={0.5}>
      <TextField
        fullWidth
        multiline
        rows={2}
        label="Dashboard Description"
        error={isCharacterLimitExceeded}
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
      />
      <Typography
        variant="caption"
        color={isCharacterLimitExceeded ? 'error' : 'text.secondary'}
      >
        {description.length}/{DASHBOARD_DESCRIPTION_MAX_LENGTH}
      </Typography>
    </Stack>
  );
};
